const WindowFilter = {
  data() {
    return {
      activeWindows: this.activeItems
    }
  },
  props: [
    'activeItems'
  ],
  watch: {
    activeItems(newValue) {
      this.activeWindows = newValue
    }
  },
  methods: {
    handleInput: function(event) {
      bus.$emit('window_filter', event.target.value)
    },
  }
}

export default WindowFilter
